import Link from 'next/link';
import { Button, Icon, Typography } from '@/components/common';
import Icons from '@/const/icons';
import { Case } from '@/interfaces';
import { ArrowUpRight, Check } from 'lucide-react';
import { formatCurrency } from '@/utils';
import AppRoutes from '@/const/routes';

export const FinancialCard: React.FC<Case> = ({ caseId, caseName, earned }) => {
	return (
		<div className="bg-gray-20 rounded-2xl p-4 space-y-4 hover:bg-white hover:border hover:border-green-base">
			<div className="flex items-center gap-2">
				<Check className="text-green-120" width={18} height={18} />
				<Typography type="semibold-14" text={'Resolved Case'} />
			</div>
			<div className="flex flex-col md:flex-row items-star md:items-center gap-4 md:gap-0 justify-between">
				<div className="flex items-center gap-1">
					<Typography type="semibold-18" className="!text-lg">
						{caseName}
					</Typography>
					<Link
						href={`${AppRoutes.CLIENTAPP_MY_CASES}/${caseId}`}
						className="hidden md:block"
					>
						<ArrowUpRight className="text-purple-150" width={18} height={18} />
					</Link>
				</div>
				<div className="flex flex-col items-end gap-3">
					<Button
						decoration="line-primary"
						size="small"
						className="!w-[156px]"
						classNameLink="!w-[156px] md:hidden"
						href={`${AppRoutes.CLIENTAPP_MY_CASES}/${caseId}`}
					>
						Review Case
					</Button>
					<div className="flex items-center gap-2">
						<Icon
							src={Icons.moneyReceive}
							className="text-green-120 !w-6 !h-6"
						/>
						<Typography
							type="semibold-18"
							text={`$${formatCurrency(String(earned))}`}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
